import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserWelcomeMessage')
export class UserWelcomeMessage {
  @JsonProperty('id', String)
  public id?: string = undefined;
  @JsonProperty('subject', String)
  public subject?: string = undefined;
  @JsonProperty('message', String)
  public message?: string = undefined;
  @JsonProperty('lang', String)
  public lang?: string = undefined;
  @JsonProperty('createdDate', String)
  public createdDate?: string = undefined;
}
